<svg width="40" height="40" viewBox="0 0 40 40" [attr.fill]=fillColor xmlns="http://www.w3.org/2000/svg">
  <g id="heart_icon">
    <path id="Vector" d="M20 12.148C17.436 9.00458 10.5581 4.63534 6.91501 12.1674C4.05839 18.0734 8.4126 21.8169 12.7912 25.5813C15.407 27.8302 18.0315 30.0866 19.1325 32.8161C19.4817 33.6816 19.7683 34.0415 20 33.9962C20.2317 34.0415 20.5183 33.6816 20.8675 32.8161C21.9685 30.0866 24.593 27.8302 27.2088 25.5813C31.5874 21.8169 35.9416 18.0734 33.085 12.1674C29.4419 4.63534 22.564 9.00458 20 12.148Z"
          [attr.fill]=fillColor />
  </g>
</svg>
